import { DatePipe } from '@angular/common';
import { Component, computed, effect, inject, input, model } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HlmTableImports } from '@spartan-ng/helm/table';

import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { Référentiel } from '../../administration/gestion-référentiels/models/référentiel.model';
import { EmptyStateComponent } from '../../shared/components/empty-state/empty-state.component';
import { InputSearchComponent } from '../../shared/components/input-search/input-search.component';
import { PaginateurComponent } from '../../shared/components/paginateur/paginateur.component';
import { URL_FRANCE_COMPETENCES } from '../../shared/models/urls-france-compétences';
import { CroisementÉtatComponent } from '../components/croisement-etat/croisement-état.component';
import { CertificationStore } from '../store/certification.store';

@Component({
  selector: 'app-croisement-referentiel-list',
  imports: [
    DatePipe,
    PaginateurComponent,
    CroisementÉtatComponent,
    ReactiveFormsModule,
    RouterModule,
    InputSearchComponent,
    EmptyStateComponent,
    HlmTableImports,
    HlmTooltipImports,
  ],
  templateUrl: './croisement-référentiel-list.component.html',
})
export class CroisementRéférentielListComponent {
  protected readonly store = inject(CertificationStore);

  filtres = model<{ nom: string; niveau?: number | null }>();
  niveau = new FormControl<number | null>(null);

  entities = computed(() => this.store.getPaginated());

  readonly referentiel = input.required<Référentiel>();

  protected urlFranceCompetences = URL_FRANCE_COMPETENCES;

  constructor() {
    effect(() => {
      const filtres = this.filtres();
      if (filtres) {
        const { nom, niveau } = filtres;
        this.store.charger({ recherche: nom!, idReferentiel: this.referentiel().id, niveau });
      }
    });
  }
}
